import React from "react";
import { Router } from "./main/routers";
import { SettingProvider } from "./usecases/Setting";
import { GaConfigure } from "./config/ga-configure";
import ReactGA from "react-ga4";
import { BrowserRouter } from "react-router-dom";

ReactGA.initialize(GaConfigure.trackingId);

function App() {
  return (
    <SettingProvider>
      <BrowserRouter>
        <Router />
      </BrowserRouter>
    </SettingProvider>
  );
}

export default App;
